import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import axios from 'axios'

Vue.use(Router)
let router = new Router({
        mode: 'history',
        routes: [{
                path: '/',
                props: true,
                component: () =>
                    import ('./components/Common/appHome2'),
                meta: {
                    requiresAuth: false,
                    isClient: true,
                    isSeller: true,
                },
                children: [{
                        path: '',
                        name: 'Home',
                        meta: {
                            requiresAuth: false,
                            isClient: true,
                            isSeller: false,
                        },
                        component: () =>
                            import ('./components/Home/home')
                    },
                    {
                        path: 'aboutUs',
                        name: 'aboutUs',
                        meta: {
                            requiresAuth: false,
                            isClient: true,
                            isSeller: true,
                        },
                        component: () =>
                            import ('./components/Policies/aboutUs'),
                    },
                    {
                        path: 'ContactUs',
                        name: 'ContactUs',
                        meta: {
                            requiresAuth: false,
                            isClient: true,
                            isSeller: true,
                        },
                        component: () =>
                            import ('./components/Policies/contactUs'),
                    },
                    {
                        path: 'privacyPolicy',
                        name: 'privacyPolicy',
                        meta: {
                            requiresAuth: false,
                            isClient: true,
                            isSeller: true,
                        },
                        component: () =>
                            import ('./components/Policies/privacyPolicy'),
                    },
                    {
                        path: 'cancellationPolicy',
                        name: 'cancellationPolicy',
                        meta: {
                            requiresAuth: false,
                            isClient: true,
                            isSeller: true,
                        },
                        component: () =>
                            import ('./components/Policies/cancellationPolicy'),
                    },
                    {
                        path: 'termsandCondition',
                        name: 'termsandCondition',
                        meta: {
                            requiresAuth: false,
                            isClient: true,
                            isSeller: true,
                        },
                        component: () =>
                            import ('./components/Policies/termsandCondition'),
                    },
                    {
                        path: 'ShippingAndDelivery',
                        name: 'shippingAndDelivery',
                        meta: {
                            requiresAuth: false,
                            isClient: true,
                            isSeller: true,
                        },
                        component: () =>
                            import ('./components/Policies/shippingAndDelivery'),
                    },
                    {
                        path: 'contact',
                        name: 'contact',
                        meta: {
                            requiresAuth: false,
                            isClient: true,
                            isSeller: false,
                        },
                        component: () =>
                            import ('./components/Products/contactInformation'),
                    },
                    {
                        path: 'products/:MainCategory(.*)?',
                        name: 'products',
                        props: true,
                        meta: {
                            requiresAuth: false,
                            isClient: true,
                            isSeller: false,
                        },
                        component: () =>
                            import ('./components/customer/viewProduct/products'),
                        children: [{
                            path: '',
                            name: 'fullProducts',
                            meta: {
                                requiresAuth: false,
                                isClient: true,
                                isSeller: false,
                            },
                            component: () =>
                                import ('./components/customer/viewProduct/fullProducts')
                        }, ]
                    },

                    {
                        path: 'productdetailview/:name(.*)?',
                        name: 'productDetailView',
                        meta: {
                            requiresAuth: false,
                            isClient: true,
                            isSeller: false,
                        },
                        component: () =>
                            import ('./components/customer/viewProduct/productDetailView')
                    },

                    {
                        path: 'sellerdetails/:id',
                        name: 'sellerdetails',
                        meta: {
                            requiresAuth: false,
                            isClient: true,
                            isSeller: false,
                        },
                        component: () =>
                            import ('./components/customer/viewProduct/sellerdetails')
                    },

                    {
                        path: 'productCart',
                        name: 'productCart',
                        meta: {
                            requiresAuth: false,
                            isClient: true,
                            isSeller: false,
                        },
                        component: () =>
                            import ('./components/customer/viewProduct/productCart')
                    },
                    {
                        path: '/buyNow',
                        name: 'buyNow',
                        meta: {
                            requiresAuth: false,
                            isClient: true,
                            isSeller: false,
                        },
                        component: () =>
                            import ('./components/customer/buyProduct/BuyNow/buyNowConfirmation')
                    },
                    {
                        path: 'cart',
                        name: 'cart',
                        meta: {
                            requiresAuth: false,
                            isClient: true,
                            isSeller: false,
                        },
                        component: () =>
                            import ('./components/customer/buyProduct/cart')
                    },
                    {
                        path: 'wishlist',
                        name: 'wishlist',
                        meta: {
                            requiresAuth: false,
                            isClient: true,
                            isSeller: false,
                        },
                        component: () =>
                            import ('./components/customer/buyProduct/wishlist')
                    },
                    {
                        path: 'myOrders',
                        name: 'My Orders',
                        meta: {
                            requiresAuth: true,
                            isClient: true,
                            isSeller: false,
                        },
                        component: () =>
                            import ('./components/customer/buyProduct/myOrders'),
                    },
                    {
                        path: '/orders',
                        meta: {
                            requiresAuth: true,
                            isClient: true,
                            isSeller: false,
                            isBrand: false,
                            isAffiliate: true,

                        },

                        component: {
                            render(c) { return c('router-view') }
                        },
                        children: [{
                                path: '',
                                name: 'Orders',
                                meta: {
                                    requiresAuth: true,
                                    isClient: true,
                                    isSeller: false,
                                    isBrand: false,
                                    isAffiliate: true,

                                },
                                component: () =>
                                    import ('./components/customer/buyProduct/orders'),
                            },
                            {
                                path: ':id',
                                name: 'MyOrderDetails',
                                meta: {
                                    requiresAuth: true,
                                    isClient: true,
                                    isSeller: false,
                                    isBrand: false,
                                    isAffiliate: true,

                                },
                                component: () =>
                                    import ('./components/customer/buyProduct/order'),
                            },
                            {
                                path: '/trackItem',
                                name: 'trackItem',
                                meta: {
                                    requiresAuth: true,
                                    isClient: true,
                                    isSeller: false,
                                    isBrand: false,
                                    isAffiliate: true,

                                },
                                component: () =>
                                    import ('./components/customer/buyProduct/trackItem'),
                            },
                        ]
                    },
                    {
                        path: 'confirmAddress',
                        name: 'confirmAddress',
                        meta: {
                            requiresAuth: false,
                            disAllow: true,
                            isClient: true,
                            isSeller: false,
                        },
                        component: () =>
                            import ('./components/customer/buyProduct/confirmAddress')
                    },
                    // payment gateway
                    {
                        path: 'payment',
                        name: 'payment',
                        meta: {
                            requiresAuth: false,
                            isClient: true,
                            isSeller: false,
                        },
                        component: () =>
                            import ('./components/customer/buyProduct/payment')
                    },
                    {
                        path: '/PaywaitScreen/:paymentId/:orderid',
                        name: 'PaywaitScreen',
                        meta: {
                            requiresAuth: true,
                            isClient: true,
                            isSeller: false,
                        },
                        props: true,
                        component: () =>
                            import ('./components/customer/buyProduct/Payment/PaywaitScreen'),
                    },
                    {
                        path: '/success/:paymentId',
                        name: 'PaywaitScreenSuccess',
                        meta: {
                            requiresAuth: true,
                        },
                        component: () =>
                            import ('./components/customer/buyProduct/Payment/Success'),
                    },
                    {
                        path: '/failure',
                        name: 'PaywaitScreenFailure',
                        meta: {
                            requiresAuth: true,
                        },
                        component: () =>
                            import ('./components/customer/buyProduct/Payment/Failure'),
                    },
                    {
                        path: 'Profile',
                        meta: {
                            label: 'Account',
                        },
                        component: () =>
                            import ('./components/Profile/profile'),
                        children: [{
                                path: '',
                                name: 'Profile',
                                meta: {
                                    label: 'Profile',
                                    requiresAuth: true,
                                    isClient: true,
                                    isSeller: true,
                                },
                                component: () =>
                                    import ('./components/Profile/profileDetails'),
                            },
                            {
                                path: 'Edit',
                                name: 'Edit Profile',
                                meta: {
                                    label: 'Edit Profile',
                                    requiresAuth: true,
                                    isClient: true,
                                    isSeller: true,
                                },
                                component: () =>
                                    import ('./components/Profile/editProfile'),
                            },

                            {
                                path: 'Orders',
                                name: 'Profle Orders',
                                meta: {
                                    requiresAuth: true,
                                    isClient: true,
                                    isSeller: false,
                                },
                                component: () =>
                                    import ('./components/Profile/orders'),
                            },
                            {
                                path: 'Wishlist',
                                name: 'Profile Wishlist',
                                meta: {
                                    requiresAuth: true,
                                    isClient: true,
                                    isSeller: false,
                                },
                                component: () =>
                                    import ('./components/Profile/wishlist'),
                            },
                            {
                                path: 'Cart',
                                name: 'Profile Cart',
                                meta: {
                                    requiresAuth: true,
                                    isClient: true,
                                    isSeller: false,
                                },
                                component: () =>
                                    import ('./components/Profile/cart'),
                            },
                            {
                                path: 'SavedAddress',
                                name: 'SavedAddress',
                                meta: {
                                    requiresAuth: true,
                                    isClient: true,
                                    isSeller: false,
                                },
                                component: () =>
                                    import ('./components/Profile/savedAddress'),
                            },

                            {
                                path: 'contact',
                                name: 'contact',
                                meta: {
                                    requiresAuth: true,
                                    isClient: true,
                                    isSeller: false,
                                },
                                component: () =>
                                    import ('./components/Products/contactInformation'),
                            },
                        ]
                    },

                ]
            },
           
            {
                path: '/Login',
                name: 'Login',
                props: true,
                component: () =>
                    import ('./components/Common/appLogin'),
                meta: {
                    requiresAuth: false,
                    isClient: true,
                    isSeller: true,
                }
            },
            {
                path: '/Products',
                component: () =>
                    import ('./components/Common/appDashboard'),
                meta: {
                    requiresAuth: false,
                    isClient: true,
                    isSeller: true,
                },
                children: [{
                        path: '',
                        name: 'Products',
                        meta: {
                            isClient: true,
                            isSeller: false,
                        },
                        component: () =>
                            import ('./components/Products/products')
                    },
                    {
                        path: ':productname/:id',
                        props: true,
                        meta: {
                            label: 'Product',
                            isClient: true,
                            isSeller: false,

                        },
                        name: 'Product Page',
                        component: () =>
                            import ('./components/Common/appProduct'),

                    },

                    {
                        path: '/Orders',
                        meta: {
                            requiresAuth: true,
                            isClient: true,
                            isSeller: false,
                        },

                        component: {
                            render(c) { return c('router-view') }
                        },
                        children: [{
                                path: '',
                                name: 'Orders',
                                meta: {
                                    requiresAuth: true,
                                    isClient: true,
                                    isSeller: false,
                                },
                                component: () =>
                                    import ('./components/Orders/orders'),
                            },
                            {
                                path: ':id',
                                name: 'MyOrderDetails',
                                meta: {
                                    requiresAuth: true,
                                    isClient: true,
                                    isSeller: false,
                                },
                                component: () =>
                                    import ('./components/Orders/order'),
                            },
                        ]
                    },
                ]
            },
          
          
            {
                path: '/sellerRegistration',
                name: 'SellerRegistration',
                meta: {
                    // requiresAuth: true,
                    // isClient: false,
                    // isSeller: true,
                },
                component: () =>
                    import ('./components/Login/sellerRegistration'),
            },
            {
                path: '/sellerStatus',
                name: 'sellerStatus',
                component: () =>
                    import ('./components/Login/sellerStatus'),
            },
           
            {
                path: '/Seller',
                meta: {
                    requiresAuth: true,
                    isClient: false,
                    isSeller: true,
                },
                component: () =>
                    import ('./components/Common/appSellerDashboard'),
                children: [{
                        path: '',
                        name: 'Seller',
                        component: () =>
                            import ('./components/Seller/Analytics/analytics'),
                    },
                    {
                        path: 'Inventory',
                        name: 'Inventory',
                        component: () =>
                            import ('./components/Seller/Inventory/inventory'),
                    },
                    {
                        path: 'ProductList',
                        name: 'ProductList',
                        component: () =>
                            import ('./components/Seller/ProductList/product'),
                    },
                    {
                        path: 'AddProduct',
                        name: 'AddProduct',
                        component: () =>
                            import ('./components/Seller/Product/addProductnew'),
                    },
                    {
                        path: 'Product/:id',
                        name: 'SellerProductDetails',
                        props: true,
                        component: () =>
                            import ('./components/Seller/ProductDetails/product'),
                    },
                    {
                        path: 'Product/Edit/:id',
                        name: 'EditProduct',
                        props: true,
                        component: () =>
                            import ('./components/Seller/Product/editProductnew'),
                    },
                    {
                        path: 'Product/:status/:id',
                        name: 'ProductStatus',
                        props: true,
                        component: () =>
                            import ('./components/Seller/Product/productStatus'),
                    },
                    {
                        path: 'SoldProducts',
                        name: 'SoldProducts',
                        component: () =>
                            import ('./components/Seller/SoldProducts/soldProducts'),
                    },
                    {
                        path: 'PendingOrders',
                        name: 'PendingOrders',
                        component: () =>
                            import ('./components/Seller/PendingOrders/pendingOrders'),
                    },
                    {
                        path: 'CancelledOrders',
                        name: 'CancelledOrders',
                        component: () =>
                            import ('./components/Seller/CancelledOrders/cancelledOrders'),
                    },
                    {
                        path: 'InventoryReport',
                        name: 'InventoryReport',
                        component: () =>
                            import ('./components/Seller/Reports/inventoryReport'),
                    },
                    {
                        path: 'SalesReport',
                        name: 'SalesReport',
                        component: () =>
                            import ('./components/Seller/Reports/salesReport'),
                    },
                    {
                        path: 'notification',
                        name: 'notification',
                        component: () =>
                            import ('./components/Seller/Notification/notification'),
                    },
                    {
                        path: 'Orders/:id',
                        name: 'OrderDetails',
                        props: true,
                        component: () =>
                            import ('./components/Seller/Order/order'),
                    },
                    {
                        path: 'Offers',
                        name: 'Offers',
                        component: () =>
                            import ('./components/Seller/Offers/offers'),
                    },
                    {
                        path: 'Offers/Add/:id',
                        name: 'AddOffer',
                        props: true,
                        component: () =>
                            import ('./components/Seller/Offers/addOffer'),
                    },
                    {
                        path: 'Deals',
                        name: 'Deals',
                        component: () =>
                            import ('./components/Seller/Deals/deals'),
                    },
                    {
                        path: 'Deals/Add/:id',
                        name: 'AddDeal',
                        props: true,
                        component: () =>
                            import ('./components/Seller/Deals/addDeal'),
                    },

                    {
                        path: 'Profile',
                        name: 'SellerProfile',
                        component: () =>
                            import ('./components/Seller/profile'),
                        props: true,

                    },
                ]
            },
            {
                path: '/Page/:id',
                name: 'GeneralPage',
                props: true,
                component: () =>
                    import ('./components/GeneralPages/generalPage'),
                meta: {
                    requiresAuth: false,
                    isClient: true,
                    isSeller: true,
                }
            },
            {
                path: '/blog',
                name: 'Blog',
                component: () =>
                    import ('./components/GeneralPages/blog'),
                meta: {
                    requiresAuth: false,
                    isClient: true,
                    isSeller: true,
                }
            },
            {
                path: '/blogDetails',
                name: 'BlogDetails',
                props: true,
                component: () =>
                    import ('./components/GeneralPages/blogDetails'),
                meta: {
                    requiresAuth: false,
                    isClient: true,
                    isSeller: true,
                }
            },
            {
                path: '/ServerError',
                name: 'ServerError',
                props: true,
                component: () =>
                    import ('./components/Common/500'),
                meta: {
                    requiresAuth: false,
                    isClient: true,
                    isSeller: true,
                }
            },
            {
                path: '*',
                name: '404PageNotFound',
                props: true,
                component: () =>
                    import ('./components/Common/404'),
                meta: {
                    requiresAuth: false,
                    isClient: true,
                    isSeller: true,
                }
            },

        ],
        scrollBehavior() {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0;
        },
    })
    // store.state.isLoggedIn == true  || to.matched.some(route => route.meta.requiresAuth == true)
router.beforeEach((to, from, next) => {

    if (to.name !== "Login") {
        localStorage.setItem("routeKey", to.fullPath)
        localStorage.setItem("prevrouteName", from.name)
        localStorage.setItem("routeName", to.path)

    }
  localStorage.setItem("LS_ROUTE_KEY",from.path);
if(localStorage.getItem("prevrouteName") == "null" && localStorage.getItem("routeName") == "/confirmAddress"){
    console.log("redirected")
    return router.push('/')
}

    if (store.state.isLoggedIn == true || to.matched.some(route => route.meta.requiresAuth == true)) {
        axios({
                method: 'POST',
                url: '/validate/token',
                headers: {
                    'x-auth-token': localStorage.getItem('token')
                }
            }).then(response => {
                if (!response.data.status) {
                    store.commit("sessionOut", true)
                    return
                }
            })
            .catch(err => {
                var msg = err;
                console.log(msg)
            });
    }
    if (to.name == 'Login' && store.state.isLoggedIn == true && (store.state.userType == 'Client')) {
        next({ name: 'Home' })
        return
    }


    if (to.name == 'Login' && store.state.isLoggedIn == true && (store.state.userType === 'Seller')) {
        next({ name: 'Seller' })
        return
    }
    if (to.matched.some(route => route.meta.isClient == false) && store.state.isLoggedIn == true && (store.state.userType == 'Client')) {
        next({ name: 'Home' })
        return
    }
    if (to.matched.some(route => route.meta.isSeller == false) && store.state.isLoggedIn == true && (store.state.userType == 'Seller')) {
        if (store.state.userData && store.state.userData.status == 'Pending') {
            if (store.state.userData.seller && store.state.userData.seller.accountnumber == undefined) {
                next({ name: 'SellerRegistration' })
                return
            }
            next({ name: 'sellerStatus' })
            return
        }
        if (store.state.userData && store.state.userData.status == 'Rejected') {
            next({ name: 'sellerStatus' })
            return
        }
        next({ name: 'Seller' })
        return
    }

    if (to.matched.some(route => route.meta.isSeller == true) && store.state.isLoggedIn == true && (store.state.userType == 'Seller')) {
        if (store.state.userData && store.state.userData.status == 'Pending') {
            if (store.state.userData.seller && store.state.userData.seller.accountnumber == undefined) {
                next({ name: 'SellerRegistration' })
                return
            }
            next({ name: 'sellerStatus' })
            return
        }
        if (store.state.userData && store.state.userData.status == 'Rejected') {
            next({ name: 'sellerStatus' })
            return
        }
    }

    next()
})

export default router